import { render, staticRenderFns } from "./SitesMenuBadge.vue?vue&type=template&id=dd9d8256&scoped=true"
import script from "./SitesMenuBadge.vue?vue&type=script&lang=js"
export * from "./SitesMenuBadge.vue?vue&type=script&lang=js"
import style0 from "./SitesMenuBadge.vue?vue&type=style&index=0&id=dd9d8256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9d8256",
  null
  
)

export default component.exports